import { useSearchParams, useNavigate } from '@remix-run/react';
import { generateURL } from '@modules-rocco/url/api/generate-url';
import { useSearchQuery } from '@ui-rocco/hooks/use-search-query';
import { useRecentlySearched } from '~/modules-rocco/search/hook/use-recently-searched';
import type { SearchIndexes } from '@modules-rocco/search/types/enum/search-indexes';
import { SEARCH_CATEGORIES } from '~/modules/search/config/search-filter';

export function useCategorySearch(initialQuery?: string) {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const recentlySearched = useRecentlySearched();

    // Use initialQuery if provided, otherwise fall back to URL search param
    const query = useSearchQuery(
        initialQuery ?? searchParams.get('search') ?? ''
    );

    const handleSearch = (finalQuery: string, searchIndex?: SearchIndexes) => {
        if (finalQuery) {
            setSearchParams({ search: finalQuery });
            recentlySearched.addRecentSearch(finalQuery);
            navigate(
                generateURL('/search', {
                    search: finalQuery,
                    ...(searchIndex !== undefined && {
                        category:
                            SEARCH_CATEGORIES.find(
                                (c) => c.index === searchIndex
                            )?.category ?? '',
                    }),
                })
            );
        }
    };

    return {
        query,
        handleSearch,
    };
}
